const bobAssets = ['guide-bob-rest.png', 'guide-bob-typing.png', 'guide-bob-blink-eyes.png'];
let ready = false;
let pending: Promise<boolean> | undefined;
const typingIntent = new WeakMap<HTMLElement, boolean>();

/** Warm the existing registered sprite family on the welcome screen. */
export function prepareGuidedBobAssets(): Promise<boolean> {
  if (!pending) pending = Promise.all(bobAssets.map(async name => {
    const image = new Image();
    image.src = `/assets/entry-identity/${name}`;
    await image.decode();
  })).then(() => { ready = true; return true; }).catch(() => { pending = undefined; return false; });
  return pending;
}

/** Never replace a visible rest frame with a sprite that has not decoded yet. */
export function setGuidedBobTyping(bob: HTMLElement, typing: boolean) {
  typingIntent.set(bob, typing);
  bob.classList.toggle('is-typing', typing && ready && bob.isConnected);
  if (typing && !ready) void prepareGuidedBobAssets().then(loaded => {
    if (loaded && bob.isConnected && typingIntent.get(bob)) bob.classList.toggle('is-typing', true);
  });
}
